import React from "react";
import { withRouter } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { eventShape } from "shapes";

import types from "./types";

import styles from "./EventDetails.css";

const EventDetails = ({ event: { end, meta, start, title, type }, history: { push } }) => {
  const eventType = types.find((t) => t.type === type);

  return (
    <div className={styles.root} onClick={() => push(eventType.url(meta))}>
      <div className={styles.content} style={{ backgroundColor: eventType.color }}>
        {start !== end && <div className={styles.time}>{moment(start).format("H:mm")}</div>}
        {eventType.title}:&nbsp;{title}
      </div>
    </div>
  );
};

EventDetails.propTypes = {
  event: PropTypes.shape(eventShape),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(EventDetails);
